<template>
  <form @submit.prevent="submitFiles" class="vehicle-photos-container">
    <h2 class="title-steps-form upload-step mb-md-0">Upload photos of your vehicle</h2>
    <div class="form-group">
      <label class="label-form-title">Please upload the following photos of you vehicle</label>
      <ul class="part-list">
        <li v-for="(part, index) in filteredParts" :key="index" class="part-list__item">
          {{ part }}
        </li>
      </ul>
    </div>
    <div class="form-group" @dragover.prevent>
      <div class="custom-file" @drop.stop.prevent="handleFileDrop">
        <input
          type="file"
          class="custom-file-input"
          name="fileInput"
          ref="fileInput"
          accept="image/*"
          multiple="True"
          @change="handleFileChange"
        />

        <div class="box-btn">
          <div>
            <label class="custom-file-label">TAKE OR UPLOAD PHOTOS</label>
            <base-button type="button" @click="handleFileClick()">
              {{ hasFiles ? 'Upload Another Photo' : 'Upload' }}
            </base-button>
          </div>
        </div>
      </div>
      <div v-if="hasFiles" class="images-container">
        <base-file
          v-for="(file, index) in files"
          :key="index"
          type="image"
          :file="file"
          :preview-url="composeFileUrl(file)"
          @delete="handleRemoveFile(index)"
        />
      </div>
      <div class="submit-form">
        <base-button
          type="submit"
          :disabled="isFilesEmpty"
          class="primary-button btn-small btn-primary"
        >
          <img src="../../../public/img/icons/check.svg" alt="icon-check" />Submit Photos
        </base-button>
      </div>
    </div>
  </form>
</template>

<script>
import BaseButton from '@/components/base-button';
import BaseFile from '@/components/base-file';

export default {
  name: 'VehiclePhotos',
  components: {
    BaseButton,
    BaseFile,
  },
  props: {
    partList: {
      type: [Array, Object],
      default: () => [],
    },
  },
  data() {
    return {
      files: [],
    };
  },
  computed: {
    filteredParts() {
      const list = !Array.isArray(this.partList) ? Object.values(this.partList) : this.partList;
      return list.filter((item) => (typeof item === 'string' ? item.trim().length > 0 : true));
    },
    hasFiles() {
      return this.files.length > 0;
    },
    isFilesEmpty() {
      return !this.hasFiles;
    },
  },
  methods: {
    setFiles(files) {
      if (!files) return;

      this.files = [...this.files, ...files];
    },
    handleFileDrop(DOMEvent) {
      this.setFiles(DOMEvent.dataTransfer.files);
    },
    handleFileChange(DOMEvent) {
      const { files } = DOMEvent.target;
      this.setFiles(files);
    },
    handleFileClick() {
      this.$refs.fileInput.click();
    },
    handleRemoveFile(idx) {
      this.files = this.files.filter((file, index) => index !== idx);
    },
    composeFileUrl(file) {
      return URL.createObjectURL(file);
    },
    submitFiles() {
      this.$emit('submit', this.files);
    },
  },
};
</script>

<style scoped lang="scss">
button[disabled] {
  opacity: 0.5;
}

.vehicle-photos-container {
  margin-bottom: 2rem;
}

.images-container {
  margin: 1rem 0;
  display: flex;
  overflow: auto;
}

.submit-form {
  border-top: 0px;
}

.part-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-row-gap: 10px;
  grid-column-gap: 10px;
  margin: 10px 0px;
  padding-left: 15px;
  list-style: none;

  @media screen and (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }

  &__item {
    color: #858585;
    font-weight: 300;
    font-family: Roboto;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 16px;
    margin-bottom: 10px;
    position: relative;
    align-items: baseline;

    &::before {
      content: '';
      position: absolute;
      margin-left: -10px;
      margin-top: 8px;
      width: 5px;
      height: 3px;
      background-color: #0088db;
      border-radius: 1px;
    }
  }
}
</style>
